<template>
  <div class="refund-list">
    <fixed-header title="售后服务"></fixed-header>
    <div
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="loading"
        :infinite-scroll-distance="30"
        class="refund-list__main scroll-touch"
    >
      <div
          v-for="(item, index) in refundList"
          :key="index"
          class="refund-list__item"
      >
        <section>
          <img :src="item.originalImg" alt=""/>
          <div>
            <p>{{ item.goodsName }}</p>
            <p>{{ item.specKeyName }}</p>
          </div>
        </section>
        <section>
          <i class="icon refund_mini"></i
          >{{ getRefundStatusTitle(item.status, item.type) }}
        </section>
        <section>
          <span @click="goToDetail(item.id)">查看详情</span>
        </section>
      </div>
      <div v-if="showNoOrder">
        <img class="refund-list__order" src="~assets/img/refund_order.png"/>
        <div class="refund-list__noOrder">您暂时没有订单记录</div>
        <div class="refund-list__goHome" @click="goToHome">随便逛逛</div>
      </div>
      <page-loading v-if="loading"></page-loading>
    </div>
    <refund-levitate></refund-levitate>
  </div>
</template>

<script>
import FixedHeader from 'components/common/FixedHeader';
import PageLoading from 'components/common/PageLoading';
import DataStorage from 'utils/dataStore';
import RefundLevitate from 'components/common/RefundLevitate';
import * as orderApi from 'apis/order';
import { getMgtvUserTicket, judgeLogin, setAsyncUserInfo } from 'utils/user';
import { getRefundStatusTitle } from 'utils/refund';
import { setFixedParams } from 'utils/uploadData';

export default {
  components: {
    FixedHeader,
    PageLoading,
    RefundLevitate,
  },
  data() {
    return {
      pageNo: 0,
      refundList: [],
      totalPages: 0,
      loading: false,
      showNoOrder: false,
      stopLoad: false,
    };
  },
  async created() {
    setTimeout(() => {
      const userInfo = getMgtvUserTicket();
      if (!(userInfo && userInfo.ticket)) {
        judgeLogin();
      }
    }, 500);
    await setFixedParams(this);
  },
  methods: {
    getRefundStatusTitle,
    /* 页面初始化就会自动执行该方法 */
    async loadMore() {
      if (this.stopLoad || this.showNoOrder) {
        return;
      }
      this.pageNo += 1;
      const userInfo = getMgtvUserTicket();
      if (!(userInfo && userInfo.ticket)) {
        await setAsyncUserInfo();
      }
      this.fetchList();
    },
    async fetchList() {
      this.loading = true;
      const { pageNo } = this;
      try {
        const { records } = await orderApi.getRefundList({ p: pageNo });
        if (Array.isArray(records)) {
          if (!records.length) {
            this.stopLoad = true;
            if (!this.refundList.length) {
              this.showNoOrder = true;
            }
          } else if (records.length < 10) {
            this.stopLoad = true;
          }
          this.refundList.push(...records);
        }
      } catch (error) {
        this.$toast(`获取数据失败：${error.message}`);
      }
      this.loading = false;
    },
    fromJifen() {
      const data = DataStorage.getStorage('jifen_shop_home', sessionStorage);
      if (data) {
        return true;
      }
      return false;
    },
    goToDetail(id) {
      this.$router.push({ path: '/refund/detail', query: { id } });
    },
    goToHome() {
      if (this.fromJifen()) {
        window.location.href = 'https://app.mgtv.com/credits/mall.html#/?from=title';
      } else {
        this.$router.push({ path: '/home' });
      }
    },
  },
};
</script>

<style lang="scss">
.refund-list {
  height: 100%;
  box-sizing: border-box;

  &__main {
    height: 100%;
    position: relative;
  }

  &__item {
    font-size: 26px;
    margin: 20px 0;

    section {
      display: flex;
      background: #fff;
    }

    section:nth-child(1) {
      padding: 30px 30px 10px 30px;

      img {
        width: 150px;
        height: 150px;
        margin-right: 30px;
      }

      div {
        flex: 1;

        p {
          margin-top: 12px;
        }

        p:last-child {
          color: #4a4a4a;
        }
      }
    }

    section:nth-child(2) {
      align-items: center;
      padding: 18px 30px;
      font-weight: 600;
      border-top: 2px solid rgba(211, 211, 211, 0.5);
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);

      i {
        margin-right: 10px;
      }
    }

    section:nth-child(3) {
      padding: 14px 30px;
      justify-content: flex-end;
      align-items: center;

      span {
        padding: 10px 26px;
        border: 2px solid #ff4c00;
        border-radius: 8px;
        color: #ff4c00;
        text-align: center;
        font-weight: 600;
      }
    }
  }

  &__goHome {
    position: absolute;
    top: 535px;
    left: 247px;
    width: 256px;
    height: 64px;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    background: url("~assets/img/refund_bt.png") no-repeat;
    background-size: cover;
    text-align: center;
    line-height: 64px;
  }

  &__noOrder {
    position: absolute;
    top: 462px;
    left: 267px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(128, 128, 128, 1);
    line-height: 48px;
  }

  &__order {
    position: absolute;
    top: 277px;
    left: 312px;
    width: 126px;
    height: 168px;
  }
}
</style>
